import CompanyIcon from './component'

export default CompanyIcon
